export const PROFILE_LIST = {
  PERSONAL_DATA: "البيانات الشخصية",
  ADDRESS: "العنوان",
  SECURITY_CODE: "تغيير رمز الأمان",
  MEANS_OF_RECEIVING: "وسائل الإستلام",
  SETTINGS: "الإعدادات",
};
export const ABSHER_SECTION = {
  CONFIRM_YOUR_IDENTITY_THROUGH_ABSHER: "أكد هويتك عبر أبشر",
  MODAL_DESCRIPTION: "قم بتأكيـد هـويتك الشخصية بسهـولة وسرعة",
  CONFIRM_YOUR_IDENTITY_BUTTON_LABEL: "تأكيد الهوية",
  IDENTITY_CONFIRMED: "تم تأكيد رقم الهوية بنجاح",
};
